import { render, staticRenderFns } from "./dispatchAbnormalRemark.vue?vue&type=template&id=5b5f04db&scoped=true&"
import script from "./dispatchAbnormalRemark.vue?vue&type=script&lang=js&"
export * from "./dispatchAbnormalRemark.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b5f04db",
  null
  
)

export default component.exports